import { getInsuranceDetailsEndpoint, InsuranceDetails, InsuranceFooterState } from '@cp-mx/common';
import { useDispatch, useSelector } from 'react-redux';
import { InsuranceDetailsSelector, InsuranceSelector } from './InsuranceDetailsContentSelector';
import { DefaultMarketApiErrors } from '@cp-shared-19/common-utilities';
import { AbstractDataState, useGetContractBasedApiData } from '@cp-shared-19/frontend-integration';
import { useMemo } from 'react';
import { fetchInsuranceDetails } from './InsuranceDetailsSlice';

export const useInsuranceFooter = () => {
    const dispatch = useDispatch();
    const insuranceFooterState = useSelector(InsuranceSelector) as InsuranceFooterState;

    return {
        insuranceFooterState,
        setInsuranceFooter: (flag: boolean) => {
            dispatch({
                type: 'hasInsurance',
                data: {
                    shown: flag,
                },
            });
        },
    };
};

export function useInsuranceDetails(
    contractId: string,
    vin?: string,
): AbstractDataState<InsuranceDetails, DefaultMarketApiErrors> {
    const insuranceDetailsState = useGetContractBasedApiData(
        contractId,
        fetchInsuranceDetails,
        InsuranceDetailsSelector,
        getInsuranceDetailsEndpoint(vin ? vin : ''),
    );
    return useMemo(
        () => ({
            isLoading: insuranceDetailsState.isLoading,
            hasReceivedResponse: insuranceDetailsState.hasReceivedResponse,
            failedLoadingAttempts: insuranceDetailsState.failedLoadingAttempts,
            data: insuranceDetailsState.data,
            loadingError: insuranceDetailsState.loadingError,
        }),
        [insuranceDetailsState],
    );
}
